import { render, staticRenderFns } from "./c-select-browse.vue?vue&type=template&id=5f8a7e83&"
import script from "./c-select-browse.vue?vue&type=script&lang=js&"
export * from "./c-select-browse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports